// extracted by mini-css-extract-plugin
export default {"desktopPlayer":"QME8t_"};